<template>
  <modal v-bind="$attrs"
         v-on="$listeners"
         :title="model.id ? $t('resumeHistory.edit') : $t('resumeHistory.add')">
    <form @submit.prevent="onSubmit" autocomplete="off">
      <fg-input :placeholder="$t('resume.history.name')"
                :label="$t('resume.history.name')"
                :name="$t('resume.history.name')"
                :error="getError($t('resume.history.name'))"
                v-validate="'required'"
                required
                class="w-full"
                v-model="model.name">
      </fg-input>

      <fg-input :placeholder="$t('resume.history.description')"
                :label="$t('resume.history.description')"
                class="w-full"
                v-model="model.description">
              <textarea v-model="model.description"
                        rows="3"
                        class="form-control"
                        :placeholder="$t('resume.history.description')"/>
      </fg-input>

      <fg-input :placeholder="$t('resume.history.institution')"
                :label="$t('resume.history.institution')"
                :name="$t('resume.history.institution')"
                :error="getError($t('resume.history.institution'))"
                v-validate="'required'"
                required
                class="w-full"
                v-model="model.institution">
      </fg-input>

      <fg-input :placeholder="$t('resume.history.place')"
                :label="$t('resume.history.place')"
                :name="$t('resume.history.place')"
                :error="getError($t('resume.history.place'))"
                v-validate="'required'"
                required
                class="w-full"
                v-model="model.place">
      </fg-input>


      <div class="flex flex-col md:flex-row">
        <fg-input :placeholder="$t('resume.history.from')"
                  :label="$t('resume.history.from')"
                  :name="$t('resume.history.from')"
                  :error="getError($t('resume.history.from'))"
                  v-validate="'required'"
                  required
                  component="el-date-picker"
                  value-format="yyyy-MM-dd"
                  v-model="model.from"
                  class="w-full md:w-1/2 md:mr-3">
        </fg-input>
        <fg-input :placeholder="$t('resume.history.till')"
                  :label="$t('resume.history.till')"
                  :name="$t('resume.history.till')"
                  :error="getError($t('resume.history.till'))"
                  v-validate="'required'"
                  required
                  component="el-date-picker"
                  value-format="yyyy-MM-dd"
                  v-model="model.till"
                  class="w-full md:w-1/2">
        </fg-input>
      </div>

      <div class="flex justify-center">
        <submit-button native-type="submit" :loading="loading"/>
      </div>
    </form>
  </modal>
</template>
<script>
import Vue from 'vue'
import { DatePicker } from 'element-ui'
import ResumeService from 'src/services/ResumeService'

Vue.use(DatePicker)
export default {
  props: {
    resumeId: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      model: {
        type: 'education',
        name: '',
        institution: '',
        place: '',
        description: '',
        from: '',
        till: ''
      }
    }
  },
  methods: {
    async onSubmit () {
      let res = await this.$validator.validateAll()
      if (!res) {
        return
      }
      try {
        this.loading = true
        if (this.model.uuid) {
          await ResumeService.updateResumeHistory(this.resumeId, this.model)
          this.$notify({type: 'success', message: this.$t('resume.history.edit.success')})
        } else {
          await ResumeService.createResumeHistory(this.resumeId, this.model)
          this.$notify({type: 'success', message: this.$t('resume.history.create.success')})
        }
        this.$emit('update:show', false)
        this.$emit('save', this.model)
        this.model = {
          type: 'education',
          name: '',
          institution: '',
          place: '',
          description: '',
          from: '',
          till: ''
        }
      } catch (err) {
        this.$notify({type: 'danger', message: this.$t('resume.history.edit.error')})
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        if (!value) {
          return
        }
        this.model = {
          ...this.model,
          ...value
        }
      }
    }
  }
}
</script>
<style>
</style>
